// ======================
// ID 工具
// ======================
export function createLocalId(prefix = 'local') {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
}

// ======================
// Guard 工具
// ======================
export function asArray(value) {
  return Array.isArray(value) ? value : []
}

export function asRecord(value) {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? value
    : {}
}

export function pickFirstString(record, keys) {
  for (const key of keys) {
    const value = record[key]
    if (typeof value === 'string' && value.trim()) {
      return value
    }
  }
  return ''
}

// ======================
// 时间 工具
// ======================
export function formatMessageTime(input) {
  if (!input) return ''

  const date = new Date(input)
  if (Number.isNaN(date.getTime())) return input

  return `${date.getHours().toString().padStart(2, '0')}:${date
    .getMinutes()
    .toString()
    .padStart(2, '0')}`
}
